<template>
    <v-container fill-height fluid grid-list-xl>
        <v-layout wrap>
            <v-flex sm12 xs12 md12 lg12 grid-list-md>
                <v-form ref="formMenu">
                    <v-container py-0>
                        <v-layout wrap>
                            <v-flex xs12 md12>
                                <v-treeview :items="items" v-model="menuSelecionado"
                                    selection-type="independent" selectable return-object open-all
                                    item-disabled="locked"></v-treeview>
                            </v-flex>                           
                        </v-layout>
                    </v-container>
                </v-form>   
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import FormMixin from '@/mixin/form'

import ApiObject from '@/api/identityProvider/object'
import ApiObjectType from '@/api/identityProvider/object-type'

import ObjectTypeConstants from '@/constants/controle-acesso/object-type'

export default {
    name: "objeto-menu",
    mixins: [ FormMixin ],
    props: {
        value:{
            type: Object,
            required: false
        }        
    },     
    watch:{
        selecionado(newValue){
            let formulario = this.$_.clone(this.value);
            formulario.menu = newValue; 
            this.$emit("input", formulario);
        }      
    },      
    data () {
        return { 
            menuObjectType: null,
            selecionado: null,
            lista:{
                menu: []
            },            
        }
    },   
    computed: {           
        items(){
            if((this.lista.menu || []).length > 0){
                return this.createMenuHierarchy(null);
            }

            return [];
        },
        menuSelecionado:{
            get(){
                if(this.selecionado != null){
                    return [ this.selecionado ];
                }

                return [];
            },
            set(value){
                if((value || []).length > 0){
                    this.$set(this, "selecionado", value[value.length - 1]);
                }
                else{
                    this.$set(this, "selecionado", null);
                }
            }
        }
    },
    async mounted(){
        const loading = this.showLoading();
        await this.listarTipoObjetoMenu();

        await this.listarMenu();
        loading.close();
    },     
    methods:{
        createMenuHierarchy(parentNode){
            let parent = this.lista.menu.filter(
                (m) => (parentNode != null && m.parentObject != null && m.parentObject.id == parentNode.id) || 
                       (parentNode == null && m.parentObject == null)
            );

            let listOfHierarchyMenu = [];
            for(let i = 0; i < parent.length; i++){
                let object = parent[i];
                object.isOpen = (parentNode != null);

                object.name = parent[i].description;
                object.child = this.createMenuHierarchy(object);

                object.children = object.child;
                object.locked = object.child.length > 0;

                listOfHierarchyMenu.push(object);
            }

            return listOfHierarchyMenu;
        },
        async listarTipoObjetoMenu(){
            const resultado = await ApiObjectType.listarPorCodigoUnico(ObjectTypeConstants.menu).catch(erro => this.showSnackbarError(erro.error));
            if(resultado.success){
                this.$set(this, "menuObjectType", resultado.data);
            }
        },  
        async listarMenu(){
            const resultado = await ApiObject.listarPorTipoObjeto(this.menuObjectType.id).catch(erro => this.showSnackbarError(erro.error));
            if(resultado.success){
                this.$set(this.lista, "menu", resultado.data);
            }
        }        
    }    
}
</script>

<style lang="scss" scoped>
@import "../../../../styles/material-dashboard/variables";

</style>
